<app-modal [dismissible]="dismissible"
           [isLoading]="isLoading"
           class="popup-info">
    <div class="modal-header"
         modal-header>
        <h5 class="modal-title">{{title}}</h5>
    </div>
    <div class="modal-body" modal-body>
        <ng-container *ngIf="tools">
            <app-tool-scan-tree
                [isMaterial]="false"
                mode="display"
                [items]="isLoading ? [] : tools?.tools">
            </app-tool-scan-tree>
        </ng-container>
    </div>
    <div class="modal-footer" modal-footer>
        <p *ngFor="let tool of tools?.items">{{tool.name}}</p>
    </div>
</app-modal>
